import { Segment, Header, Table } from 'semantic-ui-react';
import { ReconciliationEvent } from '../../../types/reconciliation.types';

type ReconciliationsPropsType = {
    reconciliationEvents: ReconciliationEvent[];
    descriptorsMap: Record<string, any>;
    schemasKnowledge: Record<number, { branchType: string; reviewType: string }>;
    restricted?: boolean;
};
function Reconciliations({ descriptorsMap, reconciliationEvents, schemasKnowledge, restricted }: ReconciliationsPropsType) {
    return (
        <Segment>
            <Header as="h5">Reconciliations</Header>
            <Table celled structured selectable>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Branch</Table.HeaderCell>
                        <Table.HeaderCell>Report ID</Table.HeaderCell>
                        <Table.HeaderCell>Field Label</Table.HeaderCell>
                        <Table.HeaderCell>Property</Table.HeaderCell>
                        <Table.HeaderCell>Current Value</Table.HeaderCell>
                        <Table.HeaderCell>Target Value</Table.HeaderCell>
                        <Table.HeaderCell>Operation</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {reconciliationEvents.map((event, index) => (
                        <Table.Row key={index} negative={event.riskLevel > 1}>
                            <Table.Cell>
                                {schemasKnowledge[event.schemaId]?.branchType ?? ""}{' '}
                                {schemasKnowledge[event.schemaId]?.reviewType ?? ""}
                            </Table.Cell>
                            <Table.Cell>{event.reportId}</Table.Cell>
                            <Table.Cell>{descriptorsMap[event.descriptorId]?.label ?? 'UNKNOWN'}</Table.Cell>
                            <Table.Cell>{event.property}</Table.Cell>
                            <Table.Cell>{restricted ? 'Unavailable' : event.currentValue}</Table.Cell>
                            <Table.Cell>{restricted ? 'Unavailable' : event.targetValue}</Table.Cell>
                            <Table.Cell>{event.operation}</Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </Segment>
    );
}

export default Reconciliations;
